import { render, staticRenderFns } from "./MyQuestions.vue?vue&type=template&id=214fa3c3&scoped=true"
import script from "./MyQuestions.vue?vue&type=script&lang=js"
export * from "./MyQuestions.vue?vue&type=script&lang=js"
import style0 from "./MyQuestions.vue?vue&type=style&index=0&id=214fa3c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214fa3c3",
  null
  
)

export default component.exports